import {CashDto} from '../../common/shared/api/gateway/CashDto.interface';
import {Cash} from '../generated/types';

export function createCash(cash: CashDto): Cash {
  return {
    discountRate: cash.discount_rate,
    setDiscountRate: cash.set_discount_rate,
  };
}
